import { render, staticRenderFns } from "./adManagement.vue?vue&type=template&id=2d04df22&scoped=true&"
import script from "./adManagement.vue?vue&type=script&lang=js&"
export * from "./adManagement.vue?vue&type=script&lang=js&"
import style0 from "./adManagement.vue?vue&type=style&index=0&id=2d04df22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d04df22",
  null
  
)

export default component.exports